import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/contexts/AuthContext';
import { AlertTriangle } from 'lucide-react';

const SessionWarning = () => {
  const { t } = useTranslation();
  const { showSessionWarning, remainingSeconds, extendSession, logout } = useAuth();

  if (!showSessionWarning) return null;

  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;
  const timeDisplay = `${minutes}:${seconds.toString().padStart(2, '0')}`;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 backdrop-blur-sm" data-testid="session-warning-overlay">
      <div className="bg-[#1A1A1A] border border-amber-500/30 rounded-lg p-6 max-w-sm w-full mx-4 shadow-2xl shadow-amber-500/10" data-testid="session-warning-dialog">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-amber-500/15 flex items-center justify-center flex-shrink-0">
            <AlertTriangle className="h-5 w-5 text-amber-400" />
          </div>
          <h3 className="text-white font-semibold text-lg" data-testid="session-warning-title">
            {t('session.warningTitle')}
          </h3>
        </div>
        <p className="text-zinc-400 text-sm mb-2" data-testid="session-warning-message">
          {t('session.warningMessage')}
        </p>
        <div className="text-center my-4">
          <span className="text-3xl font-mono font-bold text-amber-400" data-testid="session-warning-countdown">
            {timeDisplay}
          </span>
        </div>
        <div className="flex gap-3">
          <button
            onClick={extendSession}
            className="flex-1 bg-white text-black font-medium py-2.5 rounded-sm hover:bg-zinc-200 transition-colors text-sm"
            data-testid="session-extend-btn"
          >
            {t('session.extend')}
          </button>
          <button
            onClick={logout}
            className="flex-1 bg-zinc-800 text-zinc-300 font-medium py-2.5 rounded-sm hover:bg-zinc-700 border border-white/10 transition-colors text-sm"
            data-testid="session-logout-btn"
          >
            {t('session.logout')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionWarning;
